package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.SignSymptomCharacteristicOwnerType
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer
import com.jingfangpai.common.orm.mapping.enums.SignSymptomCharacteristicStatus

@Serializable
open class SignSymptomCharacteristic(var id: String? = null){
	var signSymptomId: String? = null
	var name: String? = null
	var description: String? = null
	var ownerType: SignSymptomCharacteristicOwnerType? = null
	var onwerId: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null
	var createdBy: String? = null
	var status: SignSymptomCharacteristicStatus? = null
	var weight: Int? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as SignSymptomCharacteristic
		if (id != other.id) return false
		if (signSymptomId != other.signSymptomId) return false
		if (name != other.name) return false
		if (description != other.description) return false
		if (ownerType != other.ownerType) return false
		if (onwerId != other.onwerId) return false
		if (createdOn != other.createdOn) return false
		if (createdBy != other.createdBy) return false
		if (status != other.status) return false
		if (weight != other.weight) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (signSymptomId?.hashCode() ?: 0)
		result = 31 * result + (name?.hashCode() ?: 0)
		result = 31 * result + (description?.hashCode() ?: 0)
		result = 31 * result + (ownerType?.hashCode() ?: 0)
		result = 31 * result + (onwerId?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		return result
	}

}
